import React from "react";
import {
  RiMessage3Fill,
  RiCloseLine,
  RiLayoutLeftLine,
  RiLayoutLeftFill,
} from "react-icons/ri";

interface Props {
  isSidebarOpen: boolean;
  onToggleSidebar: () => void;
  onClose: () => void;
}

const ChatHeader: React.FC<Props> = ({ isSidebarOpen, onToggleSidebar, onClose }) => (
  <div className="bg-gradient-to-r from-[#090F21] to-[#303545] px-4 py-4 flex justify-between items-center text-white shrink-0">
    <div className="flex items-center gap-3">
      <button
        onClick={onToggleSidebar}
        className="hover:bg-white/10 p-1.5 rounded-full transition-all duration-200"
        title={isSidebarOpen ? "Collapse sidebar" : "Expand sidebar"}
      >
        {isSidebarOpen ? (
          <RiLayoutLeftFill size={18} />
        ) : (
          <RiLayoutLeftLine size={18} />
        )}
      </button>
      <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center backdrop-blur-md border border-white/30">
        <RiMessage3Fill size={16} />
      </div>
      <div>
        <h3 className="font-semibold text-sm tracking-wide leading-tight">
          Inception Assistant
        </h3>
        <div className="flex items-center gap-1.5">
          <span className="w-1.5 h-1.5 bg-green-400 rounded-full animate-pulse" />
          <p className="text-[10px] text-gray-300">Always active</p>
        </div>
      </div>
    </div>
    <button
      onClick={onClose}
      aria-label="Close chat"
      className="hover:bg-white/10 p-1.5 rounded-full transition-all duration-200"
    >
      <RiCloseLine size={20} />
    </button>
  </div>
);

export default ChatHeader;
